<template>
  <div :class="['flex column items-center justify-center full-height', { 'mobile': $q.platform.is.mobile }]">
    <img
      v-if="!isAuth"
      src="/logo.svg"
      style="max-width: 700px;"
      class="q-mb-xl"
    >
    <img
      src="/404.svg"
      style="max-width: 700px;"
      class="q-mb-xl main-image"
    >
    <div
      :style="isAuth ? 'max-width: 220px;' : 'max-width: 270px;'"
      class="items-center flex column text-center"
    >
      <div class="text-black fs-16 q-mb-lg">{{ t('text.unfortunatelyPageNotFound') }}</div>
      <div class="text-grey fs-14 q-px-md q-mb-lg">
        {{ t('text.returnToThe') }}
        <RouterLink
          class="text-purple-2 link-404"
          :to="linkToDashboard"
        >
          {{ t(linkLabel) }}
        </RouterLink>,
        {{ t('text.orContactSupport') }}
      </div>
      <AppBtn
        outline
        color="purple-2"
        class="border-radius-12"
        padding="18px 23px"
        :to="linkToDashboard"
      >
        <q-icon
          :name="buttonIcon"
          left
        />
        {{ $t(buttonLabel) }}
      </AppBtn>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAccountStore } from 'stores/account';
import { useQuasar } from 'quasar';
import { useI18n } from 'vue-i18n';

import { ROUTES } from 'src/enums';
import AppBtn from 'components/AppBtn.vue';

const { t } = useI18n();

const accountStore = useAccountStore();
const $q = useQuasar();

const isAuth = computed(() => accountStore.account);

const buttonLabel = computed(() => (isAuth.value ? 'text.returnToDashboard' : 'text.returnToHomepage'));
const buttonIcon = computed(() => (isAuth.value ? 'far fa-table-layout' : 'far fa-house'));
const linkLabel = computed(() => (isAuth.value ? 'text.mainPage' : 'text.homePage'));
const linkToDashboard = computed(() => ({ name: ROUTES.DASHBOARD, replace: true, params: { blogGuid: $q.localStorage.getItem('blogGuid') } }));
</script>

<style lang="scss" scoped>
.mobile {
  padding: 0 16px;

  .main-image {
    width: 100%;
  }
}
</style>
